import axios from 'axios';
import apiCall from './../../data/app/apiCall';

const getCommonLabels = () => (sessionStorage.getItem('lng') === 'fr'
  ? require('./../../labels/labels.french.json')
  : require('./../../labels/labels.json')).commonLabels;

export const fetchPastBidSession = (staffId, bidSessionId, categoryId) => {
  const openBidsUrl = 'preferences/bid-sessions';
  const bidPreferencesUrl = `preferences/bid-session/${bidSessionId}/employee/${staffId}`;
  const otherOptionsUrl = `preferences/options/other?bidsession_id=${bidSessionId}
                          &staff_id=${staffId}&category_id=${categoryId}`;
  const bidModeRequestUrl = `preferences/bid-session-mode?bidsession_id=${bidSessionId}
                          &staff_id=${staffId}`;
  const bidScopeRequestUrl = 'preferences/displayEnabled?feature=bidScope'
  const bidScopeOptionPropertyId = 15;
  const applicationType = getCommonLabels().APPLICATION_TYPE;
  const getBidScopePreferenceOptions = `preferences/options?application_type=${applicationType}&property_code=${bidScopeOptionPropertyId}&bidsession_id=${bidSessionId}&category_id=${categoryId}&staff_id=${staffId}`;
  return axios.all([
    apiCall(openBidsUrl, 'post', { categoryId, closed: true }),
    apiCall(bidPreferencesUrl),
    apiCall(otherOptionsUrl),
    apiCall(bidModeRequestUrl),
    apiCall(bidScopeRequestUrl),
    apiCall(getBidScopePreferenceOptions)
  ]);
};

export default fetchPastBidSession;
